class Countdown {

    /**
     * @since 4.7.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.timers         = [];
        this.selector       = '[data-countdown]';
        this.selectorAmount = '[countdown-unit-amount]';
        this.units          = {
            s: 1000,
            i: 1000 * 60,
            h: 1000 * 60 * 60,
            d: 1000 * 60 * 60 * 24
        };

        // Run initialization
        this.init();
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.7.0
     * @returns object The initialized map
     */
    init() {
        // If there are no countdowns, bail
        if (!$(this.selector).length) return;

        // Listen for the smooth scroll activator
        $(this.selector).each((i, c) => {

            // Declare and initialize
            let countdown = $(c);
            let date      = countdown.attr('data-countdown-date');
            let counters  = {
                days:    countdown.find('[data-countdown-unit="days"]'),
                hours:   countdown.find('[data-countdown-unit="hours"]'),
                minutes: countdown.find('[data-countdown-unit="minutes"]'),
                seconds: countdown.find('[data-countdown-unit="seconds"]')
            };

            // Stert polling
            this.timers[i] = setInterval(() => this.countdown(
                counters, date, i
            ), 1000);

            // Prevent leaks
            return false;

        });

        // Prevent leaks
        return;
    }

    /**
     * Run the visual countdown.
     *
     * @since 4.7.0
     * @method countdown
     * @param object counters is the timer to update at an interval
     * @param string date is the future date to calculate
     * @param int index is the interval reference
     * @return void
     */
    countdown(counters = null, date = '', index = 0) {
        // Declare and initialize
        var now    = new Date();
        var remain = {};
        let then   = new Date(date);
        let diff   = then - now;

        // If then is before now, zero out
        if (0 > diff) {

            // Stop polling
            clearInterval(this.timers[index]);

            // Calculate the remaining times
            remain = {
                s: 0,
                i: 0,
                h: 0,
                d: 0,
            };

        } else {

            // Calculate the remaining times
            remain = {
                s: Math.floor((diff % this.units.i) / this.units.s),
                i: Math.floor((diff % this.units.h) / this.units.i),
                h: Math.floor((diff % this.units.d) / this.units.h),
                d: Math.floor(diff / this.units.d)
            };

        }

        if (23 == remain.h && !!counters.days.length)
            counters.days.find(this.selectorAmount)
                .text(('0' + remain.d).slice(-2));

        if (59 == remain.m && !!counters.hours.length)
            counters.hours.find(this.selectorAmount)
                .text(('0' + remain.h).slice(-2));

        if (59 == remain.s && !!counters.minutes.length)
            counters.minutes.find(this.selectorAmount)
                .text(('0' + remain.i).slice(-2));

        if (!!counters.seconds.length)
            counters.seconds.find(this.selectorAmount)
                .text(('0' + remain.s).slice(-2));
    }
}

export default Countdown;